import React from 'react'
import {useParams, useNavigate} from "react-router-dom";
import InactivityLogout from '../services/InactivityLogout';
import Header from '../components/Header'
import MemberloginlogsSection from '../components/memberLoginLogsSection'

export default function Memberloginlogs() {
  
  const {email} = useParams();
  const navigate = useNavigate();

  return (
    <>
        <InactivityLogout>
        <Header searchterm={email} />
        <MemberloginlogsSection searchterm={email} navigate={navigate}  />
        </InactivityLogout>
    </>
  )
}
